import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AffiliationsCertificationsSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        paragraph_1: "",
        paragraph_2: "",
        paragraph_3: "",
        paragraph_after_table: "",
    });

    /* ---------------- TABLE ROWS STATE ---------------- */
    const [rows, setRows] = useState([
        { school_name: "", class_range: "", affiliation_no: ""},
    ]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchACSection();
    }, []);

    const fetchACSection = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/about_page/get_affiliation_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { affiliations_section, affiliations_table } = res.data.data;

                setForm({
                    heading: affiliations_section.heading || "",
                    paragraph_1: affiliations_section.paragraph_1 || "",
                    paragraph_2: affiliations_section.paragraph_2 || "",
                    paragraph_3: affiliations_section.paragraph_3 || "",
                    paragraph_after_table: affiliations_section.paragraph_after_table || "",
                });

                setRows(
                    affiliations_table.length
                        ? affiliations_table
                        : [{ school_name: "", class_range: "", affiliation_no: "" }]
                );
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /////// Delete row //////////

    const deleteRow = (index) => {
        // 🚫 Prevent deleting the last row
        if (rows.length <= 1) {
            return;
        }

        const updated = rows.filter((_, i) => i !== index);

        // reassign sort_order after delete
        const reordered = updated.map((row, i) => ({
            ...row,
            sort_order: i + 1,
        }));

        setRows(reordered);
    };

    /* ---------------- Input Change ---------------- */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // row handler
    const handleRowChange = (index, e) => {
        const updated = [...rows];
        updated[index][e.target.name] = e.target.value;
        setRows(updated);
    };

    // + Add Row
    const addRow = () => {
        setRows([
            ...rows,
            {
                school_name: "",
                class_range: "",
                affiliation_no: "",
            },
        ]);
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("rows", JSON.stringify(rows));


            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/add_edit_affiliation_section`,
                formData,
                { withCredentials: true }
            );

            setMessage(res.data.msg);
            fetchACSection();
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Affiliations and Certifications section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Affiliations and Certifications section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Affiliations and Certifications section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Paragraph 1 */}
                                        <div className="form-group">
                                            <label>Paragraph 1</label>
                                            <textarea
                                                name="paragraph_1"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Paragraph 1"
                                                value={form.paragraph_1}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Paragraph 2 */}
                                        <div className="form-group">
                                            <label>Paragraph 2</label>
                                            <textarea
                                                name="paragraph_2"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Paragraph 2`}
                                                value={form.paragraph_2}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Paragraph 3 */}
                                        <div className="form-group">
                                            <label>Paragraph 3</label>
                                            <textarea
                                                name="paragraph_3"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Paragraph 3`}
                                                value={form.paragraph_3}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Affiliation Table */}
                                        <div className="form-group">
                                            <label>Affiliation table</label>
                                            {rows.map((row, index) => (
                                                <div key={index} style={{ display: "flex", gap: "10px", marginTop: "7px" }}>
                                                    <input
                                                        type="text"
                                                        name="school_name"
                                                        placeholder="School Name"
                                                        value={row.school_name}
                                                        onChange={(e) => handleRowChange(index, e)}
                                                    />

                                                    <input
                                                        type="text"
                                                        name="class_range"
                                                        placeholder="Class range"
                                                        value={row.class_range}
                                                        onChange={(e) => handleRowChange(index, e)}
                                                    />

                                                    <input
                                                        type="text"
                                                        name="affiliation_no"
                                                        placeholder="Affiliation No"
                                                        value={row.affiliation_no}
                                                        onChange={(e) => handleRowChange(index, e)}
                                                    />

                                                    {/* DELETE BUTTON */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow(index)}
                                                        disabled={rows.length === 1}
                                                        title={
                                                            rows.length === 1
                                                                ? "At least one row is required"
                                                                : "Delete row"
                                                        }
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button className="btn btn-success mt-3" type="button" onClick={addRow}>
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* Paragraph after table */}
                                        <div className="form-group">
                                            <label>Paragraph after table</label>
                                            <textarea
                                                name="paragraph_after_table"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Paragraph after table`}
                                                value={form.paragraph_after_table}
                                                onChange={handleChange}
                                            />
                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default AffiliationsCertificationsSection;